import { PermissionAccessTypes } from '../../slices/accounts/account';

export const isPermissionAvailable = (permission?: PermissionAccessTypes): boolean => {
  return permission === PermissionAccessTypes.Available;
};

export const isPermissionDisabled = (permission?: PermissionAccessTypes): boolean => {
  return permission === PermissionAccessTypes.Disabled;
};

export const isPermissionHidden = (permission?: PermissionAccessTypes): boolean => {
  return permission === PermissionAccessTypes.Hidden;
};